<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.booking')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('header.mall') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="banner"></div>
    <div class="cart-bar">
      <div class="my-cart" @click="toCart()">
        <img src="@/assets/images/icon-cart.png" />
        <span>我的购物车</span>
        <span class="sl">{{ cartNum }}</span>
        <span>&gt;</span>
      </div>
    </div>
    <el-tabs class="guide-tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        :label="namesItem.name"
        v-for="(namesItem, namesIndex) in namesDict.sub"
        :key="namesIndex"
      >
        <div v-if="goodsInfo && goodsInfo.length > 0">
          <ul class="list clearfix">
            <li
              v-for="(tItem, tIndex) in goodsInfo"
              :key="tIndex"
              @click="toDetail(tItem.id)"
            >
              <img
                v-if="tItem.s_pic.length > 0"
                :src="getImageUrl(tItem.s_pic)"
                alt=""
              />
              <img
                v-if="tItem.s_pic.length == 0"
                src="../../assets/images/goods-image-default.jpg"
                alt=""
              />
              <div class="text">
                <!-- <h3>{{ tItem.brand_name }}</h3> -->
                <h3>{{ tItem.name }}</h3>
                <p>
                  ￥{{ tItem.price }} <span>￥{{ tItem.offer_price }}</span>
                </p>
              </div>
            </li>
          </ul>
          <el-pagination
            v-if="goodsInfo && goodsInfo.length > 0"
            background
            layout="prev, pager, next"
            :page-count="pageAll"
            :current-page="current_page"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
        <div class="noGoodsShow" v-else>该品类暂无商品</div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import routerTo from '@/router/routerTo';
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import mall from '@/api/mall';
import { getImageAllUrl } from '@/setup/common';
export default {
  data() {
    return {
      activeName: '0',
      namesDict: {},
      goodsInfo: [],
      cate_id: '',
      page: 1,
      pageAll: 0,
      current_page: 1,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    cartNum() {
      return this.$store.getters.cartAllNumShow;
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.getAllNames();
  },
  methods: {
    currentChange(value) {
      // console.log('page是', value);
      this.page = value;
      this.getGoodsByIdList(this.cate_id);
    },
    toCart() {
      routerTo.FromMallHomeToCart(this.$router, false);
    },
    toDetail(goods_id) {
      routerTo.toDetail(this.$router, false, { goodsId: goods_id });
    },
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    handleClick(tab) {
      this.activeName = tab.index;
      this.cate_id = this.namesDict.sub[parseInt(tab.index)].id;
      this.page = 1;
      this.getGoodsByIdList(this.cate_id);
    },
    getImageUrl(imagePath) {
      return getImageAllUrl(imagePath);
    },
    async getAllNames() {
      const getAllNames = await mall.getAllNames({
        product_code: process.env.VUE_APP_MALL_PRODUCT_CODE,
        store_id: '0',
      });
      this.namesDict = getAllNames[0];
      this.cate_id = this.namesDict.sub[0].id;
      this.getGoodsByIdList(this.cate_id);
    },
    async getGoodsByIdList(cate_id) {
      this.goodsInfo = [];
      const getGoodsByIdList = await mall.getGoodsByIdList({
        product_code: process.env.VUE_APP_MALL_PRODUCT_CODE, //TODO
        cate_id: cate_id,
        page: this.page,
        page_size: 16,
      });
      this.goodsInfo = getGoodsByIdList.goods_info;
      let orderNumberTotal = getGoodsByIdList.total;
      this.pageAll = getGoodsByIdList.page_total; //Math.ceil(orderNumberTotal / 2);
      this.current_page = getGoodsByIdList.current_page;
      /*
      if(this.goodsInfo.length>0 && this.goodsInfo[0].store_name){
        localStorage.setItem("store_name",this.goodsInfo[0].store_name)
      }*/
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.banner {
  height: 240px;
  margin-bottom: 0;
  background-image: url(../../assets/images/banner-4.jpg);
}
.cart-bar {
  width: 1100px;
  margin: 0 auto;
  position: absolute;
  top: 370px;
  right: 0;
  left: 0;
  z-index: 99;
  text-align: right;
  .my-cart {
    display: flex;
    justify-content: space-between;
    float: right;
    padding: 6px 10px;
    border: 1px solid #eee;
    border-radius: 4px;
    background: #f8f8f8;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
    }
    span {
      margin-left: 6px;
    }
    .sl {
      width: 20px;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      background: #f15b49;
    }
  }
}
.guide-tabs /deep/ .el-tabs__header {
  height: 54px;
  margin-bottom: 20px;
  background: #fff;
}
.guide-tabs /deep/ .el-tabs__nav-wrap {
  width: 1100px;
  margin: 0 auto;
}
.guide-tabs /deep/ .el-tabs__nav-wrap::after {
  height: 0;
  background: none;
}
.guide-tabs /deep/ .el-tabs__nav {
  z-index: 100;
  border: none;
}
.guide-tabs /deep/ .el-tabs__item {
  height: 54px;
  margin-right: 10px;
  padding: 0 25px !important;
  border: none;
  color: #515457;
  font-size: 16px;
  line-height: 54px;
  text-align: center;
}
.guide-tabs /deep/ .el-tabs__item.is-active {
  border-bottom: 2px solid #31a775;
  color: #31a775;
}
.guide-tabs /deep/ .el-tabs__active-bar {
  height: 0;
  background: none;
}
.guide-tabs /deep/ .el-tabs__content {
  margin-bottom: 20px;
}
.noGoodsShow {
  padding: 50px;
  color: gray;
  text-align: center;
}
.list {
  width: 1100px;
  margin: 0 auto;
  li {
    float: left;
    width: 255px;
    margin: 10px 10px 10px 10px;
    text-align: left;
    background: #fff;
    cursor: pointer;
    img {
      width: 255px;
      height: 255px;
    }
    .text {
      padding: 15px 15px;
      h3 {
        height: 40px;
        margin-bottom: 5px;
        font-weight: normal;
        font-size: 16px;
      }
      p {
        color: #f04c15;
        span {
          margin-left: 6px;
          color: #ccc;
          text-decoration: line-through;
        }
      }
    }
  }
}
.el-pagination {
  margin: 40px 0 60px;
  text-align: center;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #31a775;
}
.clearfix:after,
#container:after {
  display: block;
  clear: both;
  height: 0;
  content: '.';
  visibility: hidden;
}
.clearfix,
#container {
  display: block;
}
* html .clearfix,
* html #container {
  height: 1%;
}
.clear {
  clear: both;
}
</style>
